import React from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { Row } from "./Row";

export interface TransactionTypeFieldProps {
  isMoneyIn: boolean;
  loading?: boolean;
  isUpdate: boolean;
  /** Called with the next direction when the user picks Money In/Out. */
  onDirectionChange: (isMoneyIn: boolean) => void;
  /** Called when the user picks the Journal Entry option (add flow only). */
  onJournalEntry: () => void;
}

export function TransactionTypeField({
  isMoneyIn,
  loading,
  isUpdate,
  onDirectionChange,
  onJournalEntry,
}: TransactionTypeFieldProps) {
  return (
    <Row className="transaction-type">
      <TextField
        select
        fullWidth
        disabled={loading}
        margin="dense"
        variant="outlined"
        label="Transaction Type"
        value={isMoneyIn ? "money-in" : "money-out"}
        onChange={(event) => {
          if (event.target.value === "journal-entry") {
            onJournalEntry();
            return;
          }
          onDirectionChange(event.target.value === "money-in");
        }}
      >
        <MenuItem value="money-out">Money Out</MenuItem>
        <MenuItem value="money-in">Money In</MenuItem>
        {isUpdate ? null : (
          <MenuItem value="journal-entry">Journal Entry</MenuItem>
        )}
      </TextField>
    </Row>
  );
}
